const toJsDate = (value) => {
  if (!value) {
    return null;
  }

  if (typeof value?.toDate === "function") {
    const timestampDate = value.toDate();
    return Number.isNaN(timestampDate?.getTime?.()) ? null : timestampDate;
  }

  if (value instanceof Date) {
    return Number.isNaN(value.getTime()) ? null : value;
  }

  if (typeof value === "object" && typeof value.seconds === "number") {
    const fromSeconds = new Date(value.seconds * 1000);
    return Number.isNaN(fromSeconds.getTime()) ? null : fromSeconds;
  }

  const parsedDate = new Date(value);
  return Number.isNaN(parsedDate.getTime()) ? null : parsedDate;
};

export const getPostDate = (post) => toJsDate(post?.date || post?.publish_date);

const pad = (value) => String(value).padStart(2, "0");

export const formatPostDate = (post, fallback = "") => {
  const date = getPostDate(post);
  if (!date) {
    return fallback;
  }

  const day = pad(date.getDate());
  const month = pad(date.getMonth() + 1);
  const year = date.getFullYear();
  return `${day}/${month}/${year}`;
};

const getPostDateTimestamp = (post) => getPostDate(post)?.getTime() || 0;

export const sortPostsByDateDesc = (posts = []) =>
  [...posts].sort((firstPost, secondPost) => {
    const dateDiff = getPostDateTimestamp(secondPost) - getPostDateTimestamp(firstPost);
    if (dateDiff !== 0) {
      return dateDiff;
    }

    const firstTitle = firstPost?.title || "";
    const secondTitle = secondPost?.title || "";
    return secondTitle.localeCompare(firstTitle, "pl");
  });
